import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { wallpaperThumb } from "../../../../../../utils/wallpaperThumb";
import { WALLPAPER_SVG_LIBRARY_ENABLED } from "../../../../../../constants/featureFlags";
import { WallpaperLibraryGrid } from "../../../../../wallpaperLibrary";

// First row of swatches loads eagerly (high priority) so the picker isn't blank
// on open; everything below the fold is lazy + async-decoded. With a 9-column
// grid the first row is the first 9 swatches.
const EAGER_COUNT = 9;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  gap: 6px;
  margin-top: 10px;
  cursor: pointer;
`;

const Swatch = styled.img`
  width: 100%;
  height: 40px;
  border-radius: 5px;
  object-fit: cover;
  /* Soft placeholder so the grid keeps its shape while images stream in
     (prevents layout shift + a flash of empty space on slow connections). */
  background-color: #f1f2f4;
  border: ${({ selected }) => (selected ? "2px solid #99439D" : "none")};
`;

function Preset({ handleSelectWallpaper, bgWallpaper }) {
  const { wallpapersReducer } = useSelector((state) => state);
  const wallpapers = wallpapersReducer?.wallpapers ?? [];

  return (
    <>
      {WALLPAPER_SVG_LIBRARY_ENABLED && (
        <WallpaperLibraryGrid
          bgWallpaper={bgWallpaper}
          onSelect={handleSelectWallpaper}
        />
      )}
      <GridContainer>
        {wallpapers.map((p, index) => {
        const isEager = index < EAGER_COUNT;
        return (
          <Swatch
            onClick={() => handleSelectWallpaper(p)}
            key={index}
            selected={bgWallpaper === p}
            alt="wallpaper preset"
            // Request a small thumbnail variant where the CDN supports it;
            // falls back to the original URL untouched (see wallpaperThumb).
            src={wallpaperThumb(p, 96)}
            width={96}
            height={40}
            // Off-screen swatches don't fetch until scrolled into view.
            loading={isEager ? "eager" : "lazy"}
            decoding="async"
            // Prioritise the visible first row, de-prioritise the rest.
            fetchpriority={isEager ? "high" : "low"}
            draggable={false}
          />
        );
      })}
      </GridContainer>
    </>
  );
}

export default Preset;
